import { createCookies } from '@vueuse/integrations/useCookies'

import { useGlobalStore } from '@/stores/global.js'

export default function useSSRCookies(...args) {
  const req = useGlobalStore().req

  return createCookies(req)(args)
}
